const getHourMinutes = ($minutes) => {
  const mins = Number($minutes) || 0;
  if (mins > 59) {
    return `${Math.floor(mins / 60)}h ${Math.floor(mins % 60)}m`;
  } else {
    return `${mins}m`;
  }
};

export default getHourMinutes;

